export const enum AutoshipmentTemplateTabEnum {
    ACTIVE = 1,
    ARCHIVED = 2
}